import { render, staticRenderFns } from "./NegativeBalanceInsight.vue?vue&type=template&id=2ebd6adc&scoped=true"
import script from "./NegativeBalanceInsight.vue?vue&type=script&lang=js"
export * from "./NegativeBalanceInsight.vue?vue&type=script&lang=js"
import style0 from "./NegativeBalanceInsight.vue?vue&type=style&index=0&id=2ebd6adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd6adc",
  null
  
)

export default component.exports